<template>
  <div>

    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button v-if="Yetki && Kaydet" type="success" size="small" class="YeniBtn" @click="this.Submit"
                 icon="el-icon-check">{{Sayfa.ButtonAdi}}
      </el-button>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-form :rules="FormHata" :model="Form"
               @submit.prevent.native="Submit"
               ref="GiderForm"
      >
        <el-row :gutter="24">
          <el-col :span="4">
            <el-form-item label="Abone No" prop="AboneNo">
              <el-input @keyup.enter.native="AboneGetir" :disabled="Kaydet==true" v-model="Form.AboneNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="Kaydet==false">
            <el-form-item label="" prop="x">
              <el-button type="info" style="margin-top: 18px" @click="AboneGetir">GETİR</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="this.Form.AboneBilgi">
            <el-form-item label="Tutar" prop="Tutar">
              <el-input @keyup.enter.native="Submit" id="Tutar" v-model="Form.Tutar"/>
            </el-form-item>
          </el-col>

          <el-col :span="4" v-if="this.Form.AboneBilgi">
            <el-form-item label="Borçlanma Tarihi" prop="tTarihi">
              <el-date-picker
                v-model="Form.tTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="this.Form.AboneBilgi">
            <el-form-item label="Son Ödeme Tarihi" prop="sTarihi">
              <el-date-picker
                v-model="Form.sTarihi"
                type="date"
                placeholder=""
                format="dd.MM.yyyy">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" v-if="this.Form.AboneBilgi">
            <el-form-item label="Evrak No" prop="eNo">
              <el-input v-model="Form.eNo"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24" v-if="this.Form.AboneBilgi">

          <el-col :span="6" v-if="this.Form.AboneBilgi">
            <el-form-item label="Site / Bina" prop="Bina_id">
              <el-select :disabled="Kaydet==true" v-model="Form.Bina_id"
                         filterable>
                <el-option
                  v-for="item in Binalar"
                  :key="item.id"
                  :label="item.Adi"

                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="18">
            <el-form-item label="Açıklama" prop="Aciklama">
              <el-input v-model="Form.Aciklama"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <table class="table table-xs table-hover" v-if="this.TableDisplay">
        <thead>
        <tr>
          <th>Site/Bina</th>
          <th>Firma</th>
          <th>Kategori</th>
          <th>Evrak No</th>
          <th>Tutar</th>
          <th>Borçlanma Tarihi</th>
          <th>Son Ödeme Tarihi</th>
          <th>Açıklama Tarihi</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: false,
        Yetki: false,
        Kaydet: false,
        Sayfa: {
          ButtonAdi: 'Kaydet',
          Adi: 'Abonelik Borçlandırması',
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Arama: this.$t('eGenel.9'),
          Menu: [
            {Adi: 'Gider İşle', Link: '/muhasebe/gider/gider'},
            {Adi: 'Excel Yükle', Link: '/muhasebe/gider/excel'},
          ],
          MenuDisplay: true,
        },
        Table: [],
        Binalar: [],
        TableDisplay: false,
        Form: {
          AboneBilgi: null,
          AboneNo: null,
          Bina_id: null,
          Tutar: null,
          Cari_id: null,
          Kategori_id: null,
          tTarihi: null,
          sTarihi: null,
          Aciklama: null,
          Abonelik_id: null,
        },
        FormHata: {
          AboneNo: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Bina_id: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          tTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          sTarihi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Tutar: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Aciklama: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
        },
      }
    },
    methods: {
      Submit() {
        if (this.Form.Tutar) {
          this.$refs['GiderForm'].validate((valid) => {
            if (valid) {
              this.lo = true;
              this.$store.dispatch("Post", {...this.Form, path: 'muhasebe/gider/gider'})
                .then(response => {
                  this.lo = false;
                  if (response.Durum == "OK") {
                    this.$message.success(response.Mesaj);
                    this.Sifirla();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          })
        }
      },
      Sifirla() {
        this.Form = {
          AboneBilgi: null,
          AboneNo: null,
          Bina_id: this.$store.getters.BinaBilgi.id,
          Tutar: null,
          Cari_id: null,
          Kategori_id: null,
          tTarihi: null,
          sTarihi: null,
          Aciklama: null,
          Abonelik_id: null,

        };
        this.Kaydet = false
      },
      SayfaYukle() {
        this.lo = true;
        this.$store.dispatch("Get", {path: 'yonetim/bina'})
          .then(response => {
            this.lo = false;
            if (response.Durum === 'OK') {
              this.Binalar = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
      AboneGetir() {
        this.$refs['GiderForm'].validate((valid) => {
          if (valid) {
            this.lo = true;
            this.$store.dispatch("Get", {path: 'yonetim/bina/abonelik/sorgu/' + this.Form.AboneNo})
              .then(response => {
                this.lo = false;
                if (response.Durum === 'OK') {
                  this.Form.Abonelik_id = response.Data.id;
                  this.Form.Cari_id = response.Data.Cari_id;
                  this.Form.Bina_id = response.Data.Bina_id;
                  this.Form.Kategori_id = response.Data.Kategori_id;
                  this.Form.Aciklama = response.Data.Aciklama;
                  this.Form.AboneBilgi = response.Data;
                  this.Kaydet = true
                  $("#Tutar").focus();
                } else {
                  this.$message.error("Abonelik Bulunamadı");
                }
              });
          }
        });
        var Gun = new Date();
        var AySonu = new Date(Gun.getFullYear(), Gun.getMonth() + 1, 0);
        this.Form.tTarihi = Gun;
        this.Form.sTarihi = AySonu;
      }
    },
    created() {
      this.Yetki = this.$store.getters.Yetki.muhasebe == 2 ? true : false;
      this.$store.commit("SayfaBilgi", this.Sayfa);
      this.SayfaYukle();
      //+'.'+Gun.getMonth()+'.'+Gun.getFullYear()

      if (this.$store.getters.BinaBilgi) {
        this.Form.Bina_id = this.$store.getters.BinaBilgi.id;
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Muhasebe/gider/abonelik.vue